import React, { useState, useMemo, useEffect } from "react";
import { observer } from "mobx-react";
import emissionViewStore from "../../Store/marco/emissionViewStore";
import { getConstByStandard } from "../utils/getConstFileByStandard";
import styles from "../modals/styles/EmissionActivityModal.module.css";
import { emissionFactorAPI } from "../API/emissionFactorAPI";
import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import ShareIcon from "@mui/icons-material/Share";
//翻譯
import { useTranslation } from "react-i18next";

export const IncertEFDec = observer(({ parentData }) => {
  const store = emissionViewStore;
  const CONST = getConstByStandard(store.standardId);
  const { t } = useTranslation("ActivityMain");
  const { t:t1 } = useTranslation("EFMain");
  ////////category轉換
  const category = CONST.category;
  const cat = category[emissionViewStore.selectedTab].slice(0, 4);
  const [EFDecData, setEFDecData] = useState([]);

  ////////拿取EF詳細資料
  const getEFDescription = async (efId, efTypeId) => {
    if (parentData) {
      return setEFDecData(parentData[0]);
    }

    try {
      let data = [];
      if (cat === "cat6") {
        data = await emissionFactorAPI[`${cat}EFDec`](efId);
      } else {
        data = await emissionFactorAPI[`${cat}EFDec`](efId, efTypeId);
      }
      console.log("拿到的EF詳細資料是", data);
      setEFDecData(data);
    } catch (error) {
      console.error("Error fetching EF詳細資料", error);
      setEFDecData([]);
    }
  };

  useEffect(() => {
    if (
      emissionViewStore.emissionFactorFormData?.shippingMethod == 2 ||
      emissionViewStore.emissionFactorFormData?.shippingMethod == 3
    ) {
      getEFDescription(
        emissionViewStore.emissionFactorFormData?.secondEmissionFactorId,
        emissionViewStore.emissionFactorFormData?.secondEmissionFactorTypeId
      );
    } else {
      getEFDescription(
        emissionViewStore.emissionFactorFormData?.emissionFactorId,
        emissionViewStore.emissionFactorFormData?.emissionFactorTypeId
      );
    }
  }, [
    emissionViewStore.emissionFactorFormData.emissionFactorId,
    emissionViewStore.emissionFactorFormData.secondEmissionFactorId,
  ]);

  return (
    <div className={styles.EFDec}>
      <p className={styles.EFDecTitle}>{t("Emission Factor")}</p>
      {(() => {
        const values = [
          {
            label: "CO₂",
            value: EFDecData?.co2EFValue,
          },
          {
            label: "CH₄",
            value: EFDecData?.ch4EFValue,
          },
          {
            label: "N₂O",
            value: EFDecData?.n2oEFValue,
          },
          {
            label: "HFCs",
            value: EFDecData?.hfcsEFValue,
          },
          {
            label: "PFCs",
            value: EFDecData?.pfcsEFValue,
          },
          {
            label: "SF₆",
            value: EFDecData?.sf6EFValue,
          },
          {
            label: "NF₃",
            value: EFDecData?.nf3EFValue,
          },
          {
            label: "CO₂e",
            value: EFDecData?.co2eEFValue,
          },
        ].filter(
          (item) =>
            item.value !== undefined && item.value !== null && item.value > 0
        );

        return (
          <main className={styles.EFDecMain}>
            {values.map((value, index) => (
              <div className={styles.EFDecInputWrap} key={index}>
                #{index + 1}：{value.value}{" "}
                {index === 0
                  ? EFDecData?.firstUnit
                  : index === 1
                  ? EFDecData?.secondUnit
                  : EFDecData?.thirdUnit}
              </div>
            ))}
          </main>
        );
      })()}

      <div className={styles.EFDecline}></div>
      <footer>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.descEF ? (
            t("Source Description") + "：" + t1(EFDecData.descEF)
          ) : (
            <></>
          )}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.databaseName ? (
            t("Official Source Name") + "：" + t1(EFDecData?.databaseName)
          ) : (
            <></>
          )}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.databaseDesc ? (
            t("Description") + "：" + t1(EFDecData?.databaseDesc)
          ) : (
            <></>
          )}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.databaseUpdD ? (
            t("Official Update Date") + "：" + EFDecData?.databaseUpdD
          ) : (
            <></>
          )}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.databaseURL ? (
            <>
              {t("Official Link")}：
              <a
                href={EFDecData?.databaseURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <ShareIcon />
              </a>
            </>
          ) : null}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.fileDownloadLink ? (
            <>
              {t("Platform File Download")}：
              <a href={EFDecData.fileDownloadLink}>
                <SimCardDownloadIcon />
              </a>
            </>
          ) : null}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.fileName ? (
            t("File Name") + "：" + t1(EFDecData?.fileName)
          ) : (
            <></>
          )}
        </p>
        <p className={styles.EFDecSmallTitle}>
          {EFDecData?.fileDesc ? (
            t("Remarks") + "：" + t1(EFDecData?.fileDesc)
          ) : (
            <></>
          )}
        </p>
      </footer>
    </div>
  );
});
